function tasilPlus() {
	var sendBriefBtn = $("#sendBrief"),
		sendBriefForm = $("#tasil-plus-form"),
		formData = new FormData(),
		formParams,
		invalidName = $(".validate-message--name"),
		invalidCompanyName = $(".validate-message--company"),
		invalidIndustry = $(".validate-message--industry"),
		invalidPhone = $(".validate-message--phone"),
		invalidDescription = $(".validate-message--description"),
		invalidFile = $(".validate-message--file"),
		invalidFileSize = $(".validate-message--file-size"),
		sendingError = $(".validate-message--fail"),
		fileInput = sendBriefForm.find("#fileInput")[0],
		maxFileSize = 5242880, // 5mb
		invalidEmail = $(".validate-message--email"),
		errorMessages = $(".valid-tasil-plus"),
		sendBriefInputs = sendBriefForm.find("input"),
		sendBriefInputsLabels = sendBriefForm.find(".input__label"),
		tasilPlusFormLoader = $("#tasilPlusFormLoader");
	var allowedFileTypes = [
		"pdf",
		"doc",
		"docx",
		"odt",
		"xls",
		"xlsx",
		"ods",
		"ppt",
		"pptx",
		"txt",
		"csv"
	];

	function showConfirmation() {
		$("#confirmation_msg").removeClass("hidden");
	}

	errorMessages.hide();

	function formIsCorrect() {
		var notCorrectInputs = sendBriefInputs.not(".correct").length;
		return notCorrectInputs == 0;
	}

	function isFileInCorrectFormat() {
		var nameParts = fileInput.value.split(".");
		var type = nameParts[nameParts.length - 1];
		var valid = false;
		for (var i = 0; i < allowedFileTypes.length; i++) {
			if (type == allowedFileTypes[i]) {
				valid = true;
			}
		}
		return valid;
	}

	$(sendBriefInputsLabels).on("click", function () {
		var labelIsFor = $(this).attr("for");
		$('[name="' + labelIsFor + '"]').focus();
	});

	$(fileInput).on("change", function () {
		var fileSize = fileInput.files[0].size;
		function switchToError() {
			$(fileInput).addClass("error").removeClass("correct");
		}
		if (fileSize === 0 || !isFileInCorrectFormat()) {
			invalidFile.show();
			switchToError();
		} else if (fileSize > maxFileSize) {
			invalidFileSize.show();
			switchToError();
		} else {
			invalidFile.hide();
			invalidFileSize.hide();
			$(fileInput).removeClass("error").addClass("correct");
		}
	});

	function validateEmptyInputs() {
		$.each(sendBriefInputs, function (index, element) {
			var el = $(element);
			if (el.val() == "") {
				el.addClass("error");
			}
			if (el.attr("type") == "file" && el.val() == "") {
				invalidFile.show();
			}
		});
	}

	function invalidField(response, validationName) {
		return response.codes.indexOf(validationName) > -1;
	}

	sendBriefBtn.on("click", function (e) {
		e.preventDefault();
		if (formIsCorrect()) {
			if (isStageEnv) {
				$("#tasil-plus-form-captcha").closest("form").submit();
			} else {
				sendBrief(e);
			}
		} else {
			validateEmptyInputs();
		}
	});

	sendBriefForm.on("submit", function (e) {
		e.preventDefault();
		if (formIsCorrect()) {
			sendBriefBtn.prop("disabled", true);
			$.each(sendBriefForm.find('input[type="file"]'), function (i, tag) {
				$.each($(tag)[0].files, function (i, file) {
					formData.append(tag.name, file);
				});
			});
			formParams = sendBriefForm.serializeArray();
			$.each(formParams, function (i, val) {
				formData.append(val.name, val.value);
			});
			tasilPlusFormLoader.addClass("active");
			$.ajax({
				url: apiPath + "sendBrief",
				type: "POST",
				data: formData,
				contentType: false,
				processData: false,
				success: function (data) {
					if (data.message == "success") {
						sendBriefForm[0].reset();
						sendBriefForm.find("input").each(function (index, el) {
							$(el).removeClass("touched").removeClass("correct");
						});
						showConfirmation();
					} else {
						var responseJson = JSON.parse(data.message);
						$.each(responseJson, function (i, val) {
							if (invalidField(val, "ValidPhone.phone")) {
								invalidPhone.show();
							} else if (invalidField(val, "NotBlank.industry")) {
								invalidIndustry.show();
							} else if (invalidField(val, "NotBlank.companyName")) {
								invalidCompanyName.show();
							} else if (invalidField(val, "NotBlank.name")) {
								invalidName.show();
							} else if (invalidField(val, "NotNull.file")) {
								invalidFile.show();
							} else if (invalidField(val, "NotBlank.description")) {
								invalidDescription.show();
							} else if (invalidField(val, "ValidEmail.email")) {
								invalidEmail.show();
							}
						});
					}
					tasilPlusFormLoader.removeClass("active");
				},
				error: function () {
					tasilPlusFormLoader.removeClass("active");
					sendingError.show();
				}
			});
		} else {
			validateEmptyInputs();
		}
		return false;
	});
}
